"use client";

import { useCategoriesQuery } from "@/hooks/Query/useCategories";
import { pushUserIdToDataLayer } from "@/lib/gtm";
import { useAppSelector } from "@/lib/hooks";
import { Category } from "@/models/category";
import UserServices from "@/services/main/UserServices";
import { useQueryClient } from "@tanstack/react-query";
import moment from "moment";
import { useEffect } from "react";

export default function ClientDispatcher({
  locale,
  categories,
  children,
}: {
  categories: Category[];
  locale: string;
  children: React.ReactNode;
}) {
  const { user: userStore } = useAppSelector((state) => state.auth);
  const queryClient = useQueryClient();
  const categoriesWP = useCategoriesQuery({
    params: {
      language: locale,
    },
    options: {
      initialData: categories,
    },
  });
  useEffect(() => {
    const syncUserLanguage = async () => {
      const userLang = userStore?.language;
      if (userLang && locale !== userLang) {
        await UserServices.changeLanguage({ language: locale });
        queryClient.setQueryData(["user"], (oldData: any) => {
          return { ...oldData, language: locale };
        });
      }
      moment.locale(locale);
    };
    syncUserLanguage();
  }, [locale, userStore?.language, queryClient]);

  useEffect(() => {
    if (!userStore?.id) return;
    pushUserIdToDataLayer(userStore);
  }, [userStore]);

  return <>{children}</>;
}
